<template>
  <div class="app-main" :style="mainWidth">
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
  </div>
</template>

<script>
import Bus from "@/utils/bus";

export default {
  name: "AppMain",
  data() {
    return {
      mainWidth: {
        width: "",
      },
      mainHeight: "",
      scrollBarWidth: "",
    };
  },
  computed: {
    key() {
      Bus.$emit("menuInit");
      return this.$route.fullPath;
    },
  },
  methods: {
    initMainWidth() {
      // 获取滚动条宽度
      const scrollContainer = document.createElement("div");
      const scrollContent = document.createElement("div");
      scrollContainer.style =
        "position:fixed;z-index:-1;width:48px;height:48px;overflow:scroll;";
      scrollContent.style = "height:100px;";
      scrollContainer.append(scrollContent);
      document.body.append(scrollContainer);
      this.scrollBarWidth =
        scrollContainer.offsetWidth - scrollContent.offsetWidth;
      // 设置MainWidth  =屏幕宽度-(工具栏宽度-滚动条宽度)
      this.mainWidth.width = `calc(100% - ${40 - this.scrollBarWidth}px)`;
    },
  },
  mounted() {
    this.initMainWidth();
  },
};
</script>

<style lang="scss" scoped>
.app-main {
  min-height: calc(100vh - 48px);
  width: 100%;
  overflow: hidden;
}
</style>